import { createClient, SupabaseClient } from '@supabase/supabase-js'

/**
 * Supabase client for LOS 12 — Portal de Usuario.
 *
 * NOTE: Credentials hardcoded temporarily to eliminate
 * "Supabase no está configurado" errors caused by missing
 * env vars in the deploy environment.
 *
 * The anon/publishable key is SAFE to ship to the browser —
 * Supabase is designed for this. Row-Level Security policies
 * on the database protect actual data.
 *
 * The R2 bucket secrets MUST live only inside the
 * `get-pdf-url` Supabase Edge Function — never in the frontend.
 */

const SUPABASE_URL = 'https://dzevaueigswlbxkkpvof.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_WBnPo2Y6tE9bny5F2C6-_Q_UyakdY0K'

let _client: SupabaseClient | null = null

export const isSupabaseConfigured = true

export function getSupabase(): SupabaseClient | null {
  if (_client) return _client
  _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  })
  return _client
}

/**
 * Convenience export — most call sites can just import `supabase`
 * directly instead of calling getSupabase().
 */
export const supabase = getSupabase()

/**
 * Calls the `get-pdf-url` Edge Function with a product_key.
 * Returns the signed temporary URL or throws on error.
 */
export async function fetchSignedPdfUrl(productKey: string): Promise<string> {
  const client = getSupabase()
  if (!client) {
    throw new Error('SUPABASE_NOT_CONFIGURED')
  }
  const { data, error } = await client.functions.invoke('get-pdf-url', {
    body: { product_key: productKey },
  })
  if (error) {
    throw error
  }
  const url = (data as { url?: string })?.url
  if (!url) {
    throw new Error('NO_URL_RETURNED')
  }
  return url
}
